export enum ImageSize {
  LANDSCAPE_LARGE = "LANDSCAPE_LARGE",
  LANDSCAPE_MEDIUM = "LANDSCAPE_MEDIUM",
  LANDSCAPE_SMALL = "LANDSCAPE_SMALL"
}
